import { useEffect, useRef } from "react";
import { View } from "react-native";
import useClearingTimeouts from "src/hooks/useClearingTimeouts";
import { useGatheringPreviewPublicStore } from "../../hooks/useGatheringPreviewPublicStore";
import { GatheringPreviewPublicScrollWrapperProps } from "./types";

const GatheringPreviewPublicScrollWrapper = ({
	children,
	onScroll,
}: GatheringPreviewPublicScrollWrapperProps) => {
	const setPopUpVariant = useGatheringPreviewPublicStore((state) => state.setPopUpVariant);
	const popUpVariant = useGatheringPreviewPublicStore((state) => state.popUpVariant);
	const curPopUpVariant = useRef(popUpVariant);
	useEffect(() => {
		curPopUpVariant.current = popUpVariant;
	}, [popUpVariant]);

	const isDebounced = useRef(true);
	const prevOffset = useRef(0);
	const didPrompt = useRef(false);
	const { createClearingTimeout } = useClearingTimeouts();
	useEffect(() => {
		const handleScroll = () => {
			onScroll?.({
				scrollY: window.scrollY,
			});
			if (!isDebounced.current) {
				prevOffset.current = window.scrollY;
				return;
			}
			isDebounced.current = false;
			createClearingTimeout(() => {
				isDebounced.current = true;
			}, 50);

			if (
				window.scrollY > 0.7 * window.innerHeight &&
				window.scrollY > prevOffset.current &&
				!didPrompt.current
			) {
				didPrompt.current = true;
				setPopUpVariant("ScrollPhotos");
			} else if (
				window.scrollY < prevOffset.current &&
				// Fix for clearing on bottom of screen bounce
				window.scrollY < 0.9 * window.innerHeight
			) {
				if (curPopUpVariant.current === "ScrollPhotos") {
					setPopUpVariant(null);
				}
				didPrompt.current = false;
			}
			prevOffset.current = window.scrollY;
		};
		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [setPopUpVariant, createClearingTimeout, onScroll]);

	return <View>{children}</View>;
};
export default GatheringPreviewPublicScrollWrapper;
